// src/modules/app-views/account/pages/Init/modals/ChangeEmailModal/Step2.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useState } from 'react';
import { Typography } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import SimpleEmail from 'components/SimpleComponents/SimpleEmail';
import appService from 'services/appService';
import translateX from 'utils/translateX';

const { Text } = Typography;

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const EnterNewEmailStepContent = ({
  form,
  newEmailDataRef,
}) => {
  const handleEmailChange = e => {
    const value = e?.target?.value || e;
    newEmailDataRef.current.email = value;
  };

  return (
    <>
      <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
        {translateX('enter_new_email_description')}
      </Text>

      <SimpleEmail
        name="newEmail"
        label="new_email"
        required
        prefix={<MailOutlined className="text-primary" />}
        onChange={handleEmailChange}
      />
    </>
  );
};

// *******************************************************************************
// HELPERS
// *******************************************************************************
const validateNewEmail = async ({ form, goFocus, newEmailDataRef }) => {
  const newEmail = form?.getFieldValue('newEmail');

  if (!newEmail || newEmail.trim() === '') {
    await appService.message({ flag: 'w', text: 'email_is_required' });
    goFocus?.('newEmail', true);
    return false;
  }

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(newEmail)) {
    await appService.message({ flag: 'w', text: 'invalid_email_format' });
    goFocus?.('newEmail', true);
    return false;
  }

  // Store the email data for Step 3
  newEmailDataRef.current.email = newEmail;

  return true;
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const enterNewEmailStep = ({ newEmailDataRef }) => {
  return {
    stepTitle: 'new_email',
    stepTooltip: 'enter_new_email',
    content: ({ form, goFocus }) => {
      return (
        <EnterNewEmailStepContent
          form={form}
          newEmailDataRef={newEmailDataRef}
        />
      );
    },
    validationFields: ['newEmail'],
    onNext: async ({ form, goFocus }) =>
      validateNewEmail({ form, goFocus, newEmailDataRef }),
    onEnter: ({ goFocus }) => {
      setTimeout(() => goFocus?.('newEmail'), 100);
    },
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default enterNewEmailStep;
